<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="品牌名称">
                    <c-input name="brand_name" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="类目">
                    <c-select name="category_id" async @search="searchCategory"></c-select>
                </m-search-item>
                <m-search-item label="备注">
                    <c-input name="remark" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="添加时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_brand_edit')" prepend-icon="tf-add"
                          @click="$refs.brandEdit.open()">添加品牌
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <!--<c-table-column type="selector" width="32"></c-table-column>-->
                <c-table-column label="ID" name="id" width="80" fixed="left"></c-table-column>

                <c-table-column
                        label="品牌名称"
                        name="brand_name"
                        width="100"
                        fixed="left"
                >
                </c-table-column>

                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                        fixed="left"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_brand_edit')" v-model="data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="品牌图片"
                        name="img_url"
                        width="80"
                >
                    <template #default="{data}">
                        <c-file v-if="data.img_url" :src="data.img_url" media style="width:50px;height:50px;"></c-file>
                        <span v-else>-</span>
                    </template>
                </c-table-column>


                <c-table-column
                        label="类目"
                        name="category_list"
                        width="200"
                >
                    <template #default="{data}">
                        <span v-if="data.category_list && data.category_list.length > 0" v-for="(item, i) in data.category_list"
                              :key="i">
                          <span v-if="i > 0">,</span>{{ item.category_name }}
                        </span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="150"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="添加人"
                        name="create_user_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="添加时间"
                        name="create_time"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="排序"
                        type="sort"
                        fixed="right"
                        @handle="sortHandle">
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="175"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_brand_channel_set')"icon="tf-related" @click="$refs.channelRefEdit.open(data,data.brand_name,'brand')">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_brand_edit')" icon="tf-edit" @click="$refs.brandEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_brand_edit')" icon="tf-trash" color="red" @click="removebrand(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--添加/编辑品牌信息弹窗-->
            <brand-edit ref="brandEdit" @resolve="$refs.list.update()"></brand-edit>
            <!--设置关联渠道信息弹窗-->
            <channel-ref-edit ref="channelRefEdit" @resolve="$refs.list.update()"></channel-ref-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import brandEdit from "@/pages/spv/brand_edit.vue";
import channelRefEdit from "@/pages/spv/channel_ref_edit.vue";

export default {
    components: {
        brandEdit,
        channelRefEdit
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },

    props: {
        type: String
    },

    data() {
        return {}
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/spu/brand/list',
                data
            });
        },

        /*******搜索类目*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /******启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/spu/brand/edit/status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1   //1：启用； 2：禁用
                },
                success: () => {
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },

        /******删除品牌***********/
        removebrand(data) {
            this.$confirm({
                message: '确认删除品牌【' + data.brand_name + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/spu/brand/remove',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /********************排序**************************/
        sortHandle(row, type, next) {
            this.request({
                url: '/spu/brand/sort',
                data: {
                    id: row.data.id,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    // next();
                    this.$refs.list.update();
                }
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>